import { Helmet } from 'react-helmet-async';
import manikchandLogo from '../../assets/images/manikchand_Logo.svg';

const ContactUsPageHelmet = () => (
  <Helmet>
    {/* Page Title */}
    <title>Namasteji Manikchand Contact</title>

    {/* Meta Description (≈155 chars) */}
    <meta
      name='description'
      content='Contact Namasteji Manikchand – the best pan masala brand in India. Reach our customer care team for inquiries, feedback, or support. Find the official Namasteji Manikchand contact number and connect with us directly.'
    />

    {/* Keywords */}
    <meta
      name='keywords'
      content='
        Namasteji Manikchand contact number,
        Namasteji Manikchand customer care,
        How to contact Namasteji Manikchand'
    />

    {/* Canonical URL */}
    <link rel='canonical' href='https://globalmanikchand.in/contact' />

    {/* Open Graph / Facebook Meta */}
    <meta property='og:type' content='website' />
    <meta property='og:title' content='Contact Namasteji Manikchand' />
    <meta
      property='og:description'
      content='Get in touch with Namasteji Manikchand, India’s finest pan masala brand. Call our customer care team or find the official contact number for quick support and assistance.'
    />
    <meta property='og:url' content='https://globalmanikchand.in/contact' />
    <meta property='og:image' content={window.location.origin + manikchandLogo} />
    <meta property='og:site_name' content='Namasteji Manikchand Official' />

    {/* Twitter Meta */}
    <meta name='twitter:card' content={window.location.origin + manikchandLogo} />
    <meta name='twitter:title' content='Contact Namasteji Manikchand' />
    <meta
      name='twitter:description'
      content='Get in touch with Namasteji Manikchand, India’s finest pan masala brand. Call our customer care team or find the official contact number for quick support and assistance.'
    />
    <meta name='twitter:image' content={window.location.origin + manikchandLogo} />
    <meta name='twitter:site' content='@NamastejiManikchand' />

    {/* Structured Data (JSON-LD) */}
    <script type='application/ld+json'>
      {`
        {
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Contact Us - Namasteji Manikchand",
          "url": "https://globalmanikchand.in/contact",
          "description": "Get in touch with Namasteji Manikchand for inquiries, partnerships, and support.",
          "publisher": {
            "@type": "Organization",
            "name": "Namasteji Manikchand",
            "logo": {
              "@type": "ImageObject",
              "url": "https://globalmanikchand.in/logo_icon.svg"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91 91063-91065",
              "contactType": "customer service",
              "areaServed": "IN",
              "availableLanguage": "en"
            }
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "523, Near Krishna Hotel, For Godown, Kanera, Mehemdabad",
            "addressLocality": "Kheda",
            "addressRegion": "Gujarat",
            "postalCode": "387130",
            "addressCountry": "IN"
          }
        }
      `}
    </script>
  </Helmet>
);

export default ContactUsPageHelmet;
